import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { FlowSelectedAction } from 'widgets/Flow'
import { useSmartCallFlowBuilderContext } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/context'
import {
  AddButtonStore,
  CallEndsStore,
  CallQueueActionEditContent,
  CallQueueStore,
  ForwardCallActionEditContent,
  ForwardCallStore,
  IncomingCallStore,
  IVRActionEditContent,
  IVRStore,
  PlayAudioActionEditContent,
  PlayAudioStore,
  RingActionEditContent,
  RingStore,
  SendSMSActionEditContent,
  SendSMSStore,
  SendToVoicemailActionEditContent,
  SendToVoicemailStore,
  AICallingAgentActionEditContent,
  AICallingAgentStore,
} from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions'

export const SelectedAction = observer(() => {
  const { selectedActionStore, closeSelectedAction, deleteAction } =
    useSmartCallFlowBuilderContext()
  const content = useMemo(() => {
    if (!selectedActionStore) return null
    if (selectedActionStore instanceof IncomingCallStore) {
      return null
    }
    if (selectedActionStore instanceof CallEndsStore) {
      return null
    }
    if (selectedActionStore instanceof AddButtonStore) {
      return null
    }
    if (selectedActionStore instanceof RingStore) {
      return <RingActionEditContent store={selectedActionStore} />
    }
    if (selectedActionStore instanceof PlayAudioStore) {
      return <PlayAudioActionEditContent store={selectedActionStore} />
    }
    if (selectedActionStore instanceof SendToVoicemailStore) {
      return <SendToVoicemailActionEditContent store={selectedActionStore} />
    }
    if (selectedActionStore instanceof ForwardCallStore) {
      return <ForwardCallActionEditContent store={selectedActionStore} />
    }
    if (selectedActionStore instanceof CallQueueStore) {
      return <CallQueueActionEditContent store={selectedActionStore} />
    }
    if (selectedActionStore instanceof SendSMSStore) {
      return <SendSMSActionEditContent store={selectedActionStore} />
    }
    if (selectedActionStore instanceof IVRStore) {
      return <IVRActionEditContent store={selectedActionStore} />
    }
    if (selectedActionStore instanceof AICallingAgentStore) {
      return <AICallingAgentActionEditContent store={selectedActionStore} />
    }
    const _exhaustiveCheck: never = selectedActionStore
    return null
  }, [selectedActionStore])

  if (!selectedActionStore) {
    return null
  }
  return (
    <FlowSelectedAction
      selectedActionStore={selectedActionStore}
      closeSelectedAction={closeSelectedAction}
      deleteAction={deleteAction}
      content={content}
    />
  )
})
